import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, type OnDestroy, type OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Subscription } from 'rxjs';
import { LinkRoles } from '../../models/link.model';
import { SafePipe } from '../../pipes/safe.pipe';
import { ConfigResourceService } from '../../services/config-resource.service';
import { BreakPoint, ResponsiveLayoutService } from '../../services/responsive-layout.service';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, MatButtonModule, SafePipe]
})
export class ContactUsComponent implements OnInit, OnDestroy {
  readonly LinkRoles = LinkRoles;
  isMobile: boolean = false;
  customText: string = '';
  primaryLogo: string = '';
  primaryLogoAltText: string = '';
  secondaryLogo: string = '';
  secondaryLogoAltText: string = '';
  locationSectionEnabled: boolean = false;
  locationTitle: string = '';
  address: string = '';
  phoneTitle: string = '';
  phoneNumber: string = '';
  hours: string = '';
  email: string = '';
  private readonly subscriptions = new Subscription();

  constructor(
    private readonly configService: ConfigResourceService,
    private readonly cdr: ChangeDetectorRef,
    private readonly responsiveLayoutService: ResponsiveLayoutService
  ) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.configService.configLoaded$.subscribe({
        next: loaded => {
          if (loaded) {
            this.customText = this.configService.getProcessedResourceValue<string>(
              'Spa_ContactUsModal_CustomText',
              'For questions, please contact a location below.'
            );
            this.primaryLogo = this.configService.getProcessedResourceValue<string>('Spa_HeaderFooter_PrimaryClientLogo', '');
            this.primaryLogoAltText = this.configService.getProcessedResourceValue<string>(
              'Spa_HeaderFooter_PrimaryLogo_Alt_Text',
              '[[ClientName]] logo'
            );
            this.secondaryLogo = this.configService.getProcessedResourceValue<string>('Spa_HeaderFooter_SecondaryClientLogo', '');
            this.secondaryLogoAltText = this.configService.getProcessedResourceValue<string>(
              'Spa_HeaderFooter_SecondaryLogo_Alt_Text',
              '[[ClientName]] logo'
            );
            this.locationSectionEnabled = this.configService.getProcessedResourceValue<boolean>(
              'Spa_ContactUsModal_LocationSection_Enabled',
              false
            );
            this.locationTitle = this.configService.getProcessedResourceValue<string>('Spa_ContactUsModal_LocationTitle', 'Address');
            this.address = this.configService.getProcessedResourceValue<string>('Spa_ContactUsModal_Address', '');
            this.phoneTitle = this.configService.getProcessedResourceValue<string>('Spa_ContactUsModal_PhoneTitle', 'Phone');
            this.phoneNumber = this.configService.getProcessedResourceValue<string>('Spa_ContactUsModal_Phone', '');
            this.hours = this.configService.getProcessedResourceValue<string>('Spa_ContactUsModal_Hours', '');
            this.email = this.configService.getProcessedResourceValue<string>('Spa_ContactUsModal_Email', '');
            this.cdr.markForCheck();
          }
        }
      })
    );

    this.subscriptions.add(
      this.responsiveLayoutService.isBreakPoint$(BreakPoint.COMPACT).subscribe({
        next: isMobile => {
          this.isMobile = isMobile;
          this.cdr.markForCheck();
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
